import React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Button, Grid } from "@mui/material";
// import FileUploadIcon from "@mui/icons-material/FileUpload";
// import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import UploadIcon from "@mui/icons-material/Upload";
import Zoom from "react-medium-image-zoom";
import CreateIcon from "@mui/icons-material/Create";
import DeleteIcon from "@mui/icons-material/Delete";
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";

// For Modal
import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
// import SequrityAlertSnoozeModal from "./SequrityAlertSnoozeModal";
import RejectRequestModal from "./RejectRequestModal";
import VerifyAtControlRoom from "./VerifyAtControlRoom";
// End

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function VerifyServiceProviderTab() {
  const navigate = useNavigate();

  // For Modal
  const [open, setOpen] = React.useState(false);
  const [scroll, setScroll] = React.useState("paper");

  const handleClickOpen = (scrollType) => () => {
    setOpen(true);
    setScroll(scrollType);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);
  // End

  // For Modal
  const [open2, setOpen2] = React.useState(false);
  const [scroll2, setScroll2] = React.useState("paper");

  const handleClickOpen2 = (scrollType) => () => {
    setOpen2(true);
    setScroll2(scrollType);
  };

  const handleClose2 = () => {
    setOpen2(false);
  };

  // const descriptionElementRef2 = React.useRef(null);
  React.useEffect(() => {
    if (open2) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open2]);
  // End

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <div>
        <div className="providerOuter">
          <div className="providerOutProfilDiv">
            <Zoom>
              <div className="provideImgDiv">
                <img src="https://i.pinimg.com/474x/7f/9d/93/7f9d93408e934aced0f2409656bca021.jpg" alt="altimg"/>
              </div>
            </Zoom>
            <h4>Devon Lane</h4>
            <p className="ageText">03 Reviews</p>
            <div className="ratingDiv">
              <StarIcon />
              <StarIcon />
              <StarIcon />
              <StarIcon />
              <StarBorderIcon />
            </div>
          </div>
        </div>
        <Box sx={{ width: "100%" }}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="scrollable auto tabs example"
              variant="scrollable"
              scrollButtons="auto"
            >
              <Tab label="Personal Info" {...a11yProps(0)} />
              <Tab label="Vehicle Details" {...a11yProps(1)} />
            </Tabs>
          </Box>
          <TabPanel value={value} index={0}>
            <Grid container spacing={0} style={{ marginTop: "50px" }}>
              <Grid item xs={12} md={6}>
                <div className="tabViewOfProvider">
                  <ul>
                    <li>
                      <span>Name</span> <b>Nevaeh Simmons</b>
                    </li>
                    <li>
                      <span>Phone Number</span> <b>(205) 555-0100</b>
                    </li>
                    <li>
                      <span>Address</span>{" "}
                      <b>2972 Westheimer Rd. Santa Ana, Illinois 85486 </b>
                    </li>
                    <li>
                      <span>Age</span> <b>21 year</b>
                    </li>
                    <li>
                      <span>Qualification</span> <b>BSC</b>
                    </li>
                  </ul>
                </div>
              </Grid>
              <Grid item xs={12} md={6}>
                <div className="tabViewOfProviderRight">
                  <h4 className="doquProviderHed">Documents</h4>
                  <div className="doquOut">
                    <div className="doquView1">
                      <Zoom>
                        <div className="doquView">
                          <img src="https://images1.livehindustan.com/uploadimage/library/2022/02/20/16_9/16_9_1/fake_aadhaar_card_1645316141.jpg" alt="altimg"/>
                        </div>
                      </Zoom>
                      <span>adharcard.jpg</span>
                    </div>
                    <div className="doquView2">
                      <div className="downLoDoqBt">
                        <UploadIcon />
                        <input type="file" />
                      </div>
                      <span>Document One</span>
                    </div>
                  </div>
                  <div className="doquOut">
                    <div className="doquView1">
                      <Zoom>
                        <div className="doquView">
                          <img src="https://upload.wikimedia.org/wikipedia/commons/3/31/A_sample_of_Permanent_Account_Number_%28PAN%29_Card.jpg" alt="altimg"/>
                        </div>
                      </Zoom>
                      <span>pancard.jpg</span>
                    </div>
                    <div className="doquView2">
                      {/* <div className="downLoDoqBt">
                        <UploadIcon />
                        <input type="file" />
                      </div>
                      <span>Document One</span> */}
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
          </TabPanel>

          <TabPanel value={value} index={1}>
            <div className="workApartInner" style={{ marginTop: "50px" }}>
              <h3 className="workApartHed">
                <span>Vehicle One</span>
                <div>
                  <CreateIcon className="editBt" onClick={() => navigate("")} />
                  <DeleteIcon className="deleteBt" />
                </div>
              </h3>
              <Grid container spacing={0}>
                <Grid item xs={12} md={6}>
                  <div className="tabViewOfProvider vehicleSpace">
                    <ul>
                      <li>
                        <span>Owner Name</span> <b>Nevaeh Simmons</b>
                      </li>
                      <li>
                        <span>Registration Number</span> <b>(205) 555-0100</b>
                      </li>
                      <li>
                        <span>Vehicle Number</span> <b>MH 20 FJ 4568 </b>
                      </li>
                    </ul>
                  </div>
                </Grid>
                <Grid item xs={12} md={6}>
                  <div className="tabViewOfProviderRight vehicleSpace">
                    <h4 className="doquProviderHed">Documents</h4>
                    <div className="doquOut">
                      <div className="doquView1">
                        <Zoom>
                          <div className="doquView">
                            <img src="https://images1.livehindustan.com/uploadimage/library/2022/02/20/16_9/16_9_1/fake_aadhaar_card_1645316141.jpg" alt="altimg"/>
                          </div>
                        </Zoom>
                        <span>adharcard.jpg</span>
                      </div>
                      <div className="doquView2">
                        <div className="downLoDoqBt">
                          <UploadIcon />
                          <input type="file" />
                        </div>
                        <span>Document One</span>
                      </div>
                    </div>
                    <div className="doquOut">
                      <div className="doquView1">
                        <Zoom>
                          <div className="doquView">
                            <img src="https://upload.wikimedia.org/wikipedia/commons/3/31/A_sample_of_Permanent_Account_Number_%28PAN%29_Card.jpg" alt="altimg"/>
                          </div>
                        </Zoom>
                        <span>pancard.jpg</span>
                      </div>
                      <div className="doquView2">
                        {/* <div className="downLoDoqBt">
                        <UploadIcon />
                        <input type="file" />
                      </div>
                      <span>Document One</span> */}
                      </div>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </div>
          </TabPanel>
        </Box>

        <Grid container spacing={0}>
          <Grid item xs={12} md={12}>
            <div className="rejectAcceptOut">
              <Button className="acpt">Accept</Button>
              <Button className="rjct" onClick={handleClickOpen("body")}>
                Reject
              </Button>
              <Button
                className="veryControlRoom"
                onClick={handleClickOpen2("body")}
              >
                Verify At Control Room
              </Button>
            </div>
          </Grid>
        </Grid>
      </div>

      <div className="modalMain">
        {/* <Button onClick={handleClickOpen("paper")}>scroll=paper</Button>
      <Button onClick={handleClickOpen("body")}>scroll=body</Button> */}
        <Dialog
          open={open}
          // onClose={handleClose}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Message</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose} />
          </DialogTitle>
          <DialogContent dividers={scroll === "paper"}>
            <div className="modalInnerCont snoozOuter">
              <div className="">
                <RejectRequestModal />
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div>

      {/* Modal 2 */}
      <div className="modalMain">
        {/* <Button onClick={handleClickOpen("paper")}>scroll=paper</Button>
      <Button onClick={handleClickOpen("body")}>scroll=body</Button> */}
        <Dialog
          open={open2}
          // onClose={handleClose2}
          scroll={scroll2}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Message</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose2} />
          </DialogTitle>
          <DialogContent dividers={scroll2 === "paper"}>
            <div className="modalInnerCont snoozOuter">
              <div className="">
                <VerifyAtControlRoom />
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </>
  );
}

export default VerifyServiceProviderTab;
